/**
 * formStyles.js - inline styles shared by the project/opportunity forms.
 * Values are verbatim from ProjectsView; other screens keep their own
 * look-alike constants because the paddings differ (see components/crm/crmStyles.js).
 */

export const INPUT = {
  width: '100%',
  padding: '8px 12px',
  borderRadius: 6,
  border: '1px solid #E0E0E0',
  fontSize: 11,
  fontFamily: 'Montserrat',
  outline: 'none',
  boxSizing: 'border-box',
};
export const LABEL = { fontSize: 10.5, fontWeight: 700, color: '#666', marginBottom: 4, display: 'block' };
export const REQUIRED = { color: '#C62828', marginLeft: 2 };
export const BTN_PRIMARY = {
  background: '#1B5E20',
  color: '#fff',
  border: 'none',
  padding: '9px 20px',
  borderRadius: 6,
  fontWeight: 700,
  fontSize: 11,
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};
